import React from 'react';
import { CheckIcon, PhoneIcon } from 'lucide-react';
import { CONTACT, MODALITY_IMAGES } from '../../data/modalities';
const highlights = ['Product-fit conversation before you invest', 'Training and implementation guidance', 'Marketing and warranty support considerations', 'A clear path for your team'];
export function FeaturedModality() {
  return <section id="product-of-the-month" className="w-full bg-slate-50 py-20 sm:py-24" data-id="element-174" data-mp="2x48ezi2kanqa">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-175" data-mp="2s4m4hge4bll6">
        <div className="grid items-center gap-10 lg:grid-cols-2" data-id="element-176" data-mp="2nbasl0ug8eme">
          <div className="order-2 lg:order-1" data-id="element-177" data-mp="2icgbc3c4qy4e">
            <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-teal" data-id="element-178" data-mp="2id99wh0xqhbg">
              Product of the Month
            </p>
            <h2 className="mt-3 font-display text-3xl font-bold leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-179" data-mp="29c1mwv3vd2wo">
              AWUSA Dual-Radial Shockwave
            </h2>
            <p className="mt-5 text-[16px] leading-relaxed text-charcoal/80" data-id="element-180" data-mp="24fkqzeqfhk91">
              A featured modality selected for practices evaluating radial
              shockwave protocols. JAG helps you understand fit, training,
              marketing support, warranty support, and implementation before you
              invest.
            </p>
            <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-181" data-mp="z4h4b6rp2k3v">
              {highlights.map(highlight => <li key={highlight} className="flex items-start gap-2.5" data-id="element-182" data-mp="1mubfljwd80m0">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal/15 text-teal" data-id="element-183" data-mp="1rsd0899fw7zl">
                    <CheckIcon className="h-3.5 w-3.5" data-id="element-184" data-mp="1drtuj8sg5e0l" />
                  </span>
                  <span className="text-[14px] font-medium text-charcoal" data-id="element-185" data-mp="1iqdi1dmouxv2">
                    {highlight}
                  </span>
                </li>)}
            </ul>
            <a href={CONTACT.phoneHref} className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy px-7 py-3.5 text-[15px] font-semibold text-white transition-colors hover:bg-navy/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2" data-id="element-186" data-mp="7csyz47c2xuj">
              <PhoneIcon className="h-[18px] w-[18px]" data-id="element-187" data-mp="1za2tqd07bxne" />
              Call About This Product
            </a>
          </div>
          <div className="order-1 lg:order-2" data-id="element-188" data-mp="1v87sf8i9tk9m">
            <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-[0_24px_60px_-24px_rgba(26,27,75,0.3)]" data-id="element-189" data-mp="1qbz6nc9kisth">
              <img src={MODALITY_IMAGES.shockwave} alt="AWUSA Dual-Radial Shockwave system" className="aspect-[4/3] w-full object-cover" data-id="element-190" data-mp="1lajnjpqyawdq" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}